/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import {
  Dialog,
  Typography,
  Grid,
  DialogContent,
  Box,
  IconButton,
  TextareaAutosize,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from 'utils/makeStylesAdapter';
import { toast } from 'react-toastify';
import { HeaderModal, ButtonConsensus, InputConsensus } from 'components';
import { colors } from 'utils/colorsSteps';
import { onCloseWithBackdropDialog } from 'utils/materialUI/backdropClickDialog';
import investigatedCertificateService from 'services/investigated-certificates/investigatedCertificateService';

const useStyles = makeStyles(() => ({
  dropzone: {
    height: '100%',
    width: '100%',
    border: '1px dashed #292929',
    display: 'flex',
    justifyContent: 'center',
    borderRadius: 10,
    cursor: 'pointer',
  },
  inputMaterial: {
    width: '100%',
  },
}));

const ModalAddJustification = props => {
  const {
    open,
    onClose,
    inquiry,
    existingCertificates,
    selectedType,
    victim,
    getCertificates,
  } = props;
  const classes = useStyles();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [justification, setJustification] = useState(
    existingCertificates?.find(cert => cert.type === selectedType)?.justification || '',
  );

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setJustification(
      existingCertificates?.find(cert => cert.type === selectedType)?.justification || '',
    );
  }, [existingCertificates, selectedType]);

  const handleChangeJustification = event => {
    setJustification(event.target.value);
  };

  const handleClose = () => {
    onClose();
  };

  const handleSaveJustification = () => {
    setLoading(true);
    investigatedCertificateService
      .saveCertificateService({
        type: selectedType,
        certificates: [],
        inquiryInvestigatedId: inquiry.id,
        justification,
        victimId: victim?.id || null,
      })
      .then(() => {
        toast.success('Justificativa adicionada com sucesso!');
        getCertificates();
        handleClose();
      })
      .catch(() => {
        toast.error('Erro ao adicionar justificativa');
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className={clsx(classes.root)}>
      <Dialog
        fullScreen={fullScreen}
        onClose={(event, reason) => onCloseWithBackdropDialog(event, reason, handleClose)}
        open={open}
        aria-labelledby="responsive-dialog-title"
        className={classes.modal}
        fullWidth
        maxWidth="md"
      >
        <HeaderModal
          backgroundColor={colors.navBar}
          colorIconTitle={colors.greySecundary}
          onClose={handleClose}
        >
          Adicionar Justificativa para Tipo {selectedType}
          {selectedType === 'Vítima' && victim?.name && ` (${victim.name})`}
        </HeaderModal>
        <DialogContent>
          <div>
            <Grid style={{ marginTop: 10 }} size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <TextareaAutosize
                style={{ width: '100%', padding: 5, resize: 'none' }}
                maxRows={4}
                minRows={4}
                aria-label="maximum height"
                placeholder="Justificativa"
                onChange={handleChangeJustification}
                name="justification"
                value={justification}
              />
            </Grid>
            <Grid container style={{ marginTop: 20, marginBottom: 20 }}>
              <Grid
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <ButtonConsensus
                  title="Salvar Justificativa"
                  type="button"
                  disabled={loading}
                  onClick={handleSaveJustification}
                />
              </Grid>
            </Grid>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default ModalAddJustification;
